import { render, staticRenderFns } from "./Monetary.vue?vue&type=template&id=563b86a3&scoped=true&"
import script from "./Monetary.vue?vue&type=script&lang=js&"
export * from "./Monetary.vue?vue&type=script&lang=js&"
import style0 from "./Monetary.vue?vue&type=style&index=0&id=563b86a3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563b86a3",
  null
  
)

export default component.exports